import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Core.Models.Mitgliedschaft.MitgliedschaftGutscheinKooperation
 * Daten der Kooperation für die Mitgliedschaft Gutscheine
 * Endpoints: /api/mitgliedschaft, /api/mitgliedschaft/erweitern, /api/mitgliedschaft/finanzdienste/kreditkarte, /api/mitgliedschaft/finanzdienste/modulkreditkarte, /api/mitgliedschaft/finanzdienste/autokredit, /api/mitgliedschaft/versicherungen/auto, /api/mitgliedschaft/profiwerber/agw, /api/mitgliedschaft/erweitern/profiwerber/agw
 */
export class MitgliedschaftGutscheinKooperationApi extends BaseApiModel {
	constructor(initialProperties?: Partial<MitgliedschaftGutscheinKooperationApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected emailKooperation: string;
	/**
	 * Description: Email des Kooperationspartner aus dem CMS
	 * APIL Type: string
	 */
	get EmailKooperation(): string {
		return this.emailKooperation;
	}

	/**
	 * Description: Email des Kooperationspartner aus dem CMS
	 * APIL Type: string
	 */
	set EmailKooperation(value: string) {
		this.emailKooperation = value;
	}

	protected code: string;
	/**
	 * Description: Gutscheincode
	 * APIL Type: string
	 */
	get Code(): string {
		return this.code;
	}

	/**
	 * Description: Gutscheincode
	 * APIL Type: string
	 */
	set Code(value: string) {
		this.code = value;
	}

	protected gutscheinwert: string;
	/**
	 * Description: Wert des Gutscheines
	 * APIL Type: string
	 */
	get Gutscheinwert(): string {
		return this.gutscheinwert;
	}

	/**
	 * Description: Wert des Gutscheines
	 * APIL Type: string
	 */
	set Gutscheinwert(value: string) {
		this.gutscheinwert = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): MitgliedschaftGutscheinKooperationApi {
		return AppUtils.Helper.createFromMap(dataObject, MitgliedschaftGutscheinKooperationApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.EmailKooperation = this.emailKooperation;
		result.Code = this.code;
		result.Gutscheinwert = this.gutscheinwert;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}